import { fullSizeText } from "./utils.js";

document.addEventListener("DOMContentLoaded", function () {
    init();
});

function init() {
    setTimeout(() => fullSizeText({ padding: 0, minFontSize: 12, maxFontSize: 1000, responsive: true }), 100);

    const menuToggle = document.getElementById("menuToggle");
    if (menuToggle) {
        function toggleMenu(e) {
            e.preventDefault();
            e.stopPropagation();

            document.body.classList.toggle("menu-open");
            menuToggle.textContent = document.body.classList.contains("menu-open") ? "close" : "menu";
        }
        menuToggle.addEventListener("click", toggleMenu, false);
    }

    // Contact Form 7
    document.addEventListener("wpcf7invalid", function (event) {
        const form = event.target;
        form.querySelectorAll(".wpcf7-not-valid-tip").forEach(existingTip => existingTip.remove());

        setTimeout(() => {
            form.querySelectorAll(".wpcf7-form-control-wrap").forEach(function (wrap) {
                const errorTip = wrap.querySelector(".wpcf7-not-valid-tip");
                if (errorTip) {
                    const labelWrapper = wrap.closest("p");
                    if (labelWrapper && labelWrapper.parentElement) {
                        errorTip.style.opacity = "1";
                        errorTip.style.display = "block";
                        labelWrapper.parentElement.insertBefore(errorTip, labelWrapper);
                    }
                }
            });

            const firstError = form.querySelector(".wpcf7-not-valid-tip");
            if (firstError) firstError.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 10);
    });
}
